var map = {
	"./smallwhatwedo - German.html": "e56d",
	"./smallwhatwedo - Ireland old.html": "9053",
	"./smallwhatwedo - Ireland.html": "9e33",
	"./smallwhatwedo - United Kingdom.html": "9a11"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0883";